import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationDeleteFolder.messages';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { createApiUrl, appSettings } from 'src/config';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


export interface ConfigurationDeleteFolderProps {
  dispatch: any;
  drilledConfirm: (folderName: string) => void;
  drilledClose: () => void;
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  parentId?: string;
  folderId?: string;
  folderName?: string;
  groups: GlobalPrivateState['groups'];
  authenticator: GlobalPrivateState['authenticator'];
  queryState: GlobalPrivateState['queryState'];
}

export interface ConfigurationDeleteFolderState {
  isOpen: boolean; 
  folderName: string; 
}

export class ConfigurationDeleteFolderPartial extends React.Component<ConfigurationDeleteFolderProps, ConfigurationDeleteFolderState> {
  constructor(props: ConfigurationDeleteFolderProps) {
    super(props);
    this.state = {
      isOpen: false,
      folderName: this.props.folderName || ''
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    const { folderName } = this.state;
    const { groups, folderId} = this.props;
    const currentFolder = folderId && groups && groups.result && groups.result.find(g => g.id === folderId);
    // Need to default populate folderName with currentFolder.name

    return (
      <Modal 
        isOpen={this.state.isOpen}
				backdrop={true}
				toggle={this.toggleModal}
        className="modal-dialog--small folder-create-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          <button onClick={this.toggleModal} className="close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
					<div>
						<h3 className="modal-heading">
              {currentFolder && currentFolder.parentId ? (
                <FormattedMessage {...MESSAGES.configurationDeleteFolderNestedHeading} />
              ) : (
                <FormattedMessage {...MESSAGES.configurationDeleteFolderHeading} />
              )}
            </h3>
						<div className="modal-body">
							<b><FormattedMessage {...MESSAGES.configurationDeleteFolderNote} /></b>&nbsp;
              {currentFolder && currentFolder.parentId ? (
                <FormattedMessage {...MESSAGES.configurationDeleteFolderNestedBody} />
              ) : (
                <FormattedMessage {...MESSAGES.configurationDeleteFolderBody} />
              )}
						</div>
						<div className="modal-actions text-center">
							<button 
								className="btn btn-light btn-bordered w-100"
								onClick={this.toggleModal}
                disabled={groups.updating}
							>
								<FormattedMessage {...MESSAGES.configurationDeleteFolderCancel} />
							</button>
							<button 
								className="btn btn-secondary w-100"
								onClick={this.handleDelete}
								disabled={groups.updating}
							>
								<FormattedMessage {...MESSAGES.configurationDeleteFolderConfirm} />
							</button>
						</div>
					</div>
        </div>
      </Modal>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  } 

  handleDelete = async (event: any) => {
    const { folderId, groups, dispatch } = this.props;

    if (!folderId) {
      return;
    }
    
    if (this.props.drilledConfirm) { 
			this.props.drilledConfirm('');
		}
		this.toggleModal();

    const apiUrl = createApiUrl(appSettings.config);
    const accessToken = this.props.authenticator.accessToken && this.props.authenticator.accessToken.id;
    if (!accessToken) return;

    // Remove folder from state
    const foldersBefore = groups.result || [];
    const updatedFolders = foldersBefore.filter(folder => folder.id !== folderId);
    dispatch(requestAPIActions.loadPlain('groups', updatedFolders));

    // Make the delete request
    const response = await fetch(`${apiUrl}/Groups/${folderId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': accessToken,
      },
    });

    // If the delete fails, restore the folder list
    if (!response.ok) {
      dispatch(requestAPIActions.loadPlain('groups', foldersBefore));
      // Optionally show a toaster popup warning
    } else {
      const queryParams: any = {
        skip: 0,
        limit: 20
      };

      if (this.props.queryState.params.sword) {
        queryParams.sword = this.props.queryState.params.sword;
      }

      if (this.props.queryState.params.tab) {
        queryParams.tab = this.props.queryState.params.tab;
      }
      this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
        'configurations', {
          url: `/Configurations/dashboard-list`,
          queryParams,
          isPager: true
        },
        false
      ));
    }
  }
}

// export const UserListDeleteModal = connect((state: GlobalPrivateState) => ({
// }))(UserListDeleteModalPartial as any);

export const ConfigurationDeleteFolder = connect((state: GlobalPrivateState) => ({
  user: state.user,
  userData: state.userData,
  groups: state.groups,
  authenticator: state.authenticator,
  queryState: state.queryState,
}))(ConfigurationDeleteFolderPartial);

export default ConfigurationDeleteFolder;